import type { ColorScheme, Theme, ThemeColors } from './tokens.js';

/** CSS custom-property prefix for all theme tokens. */
export const CSS_VAR_PREFIX = '--as';

/** camelCase -> kebab-case for CSS variable names. */
function kebab(key: string): string {
  return key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
}

/**
 * Produce the CSS-variable map for a theme + scheme. Keys look like
 * `--as-color-background`, `--as-radius-lg`, etc.
 */
export function themeToCssVars(theme: Theme, scheme: ColorScheme): Record<string, string> {
  const colors = theme.schemes[scheme];
  const vars: Record<string, string> = {};

  (Object.keys(colors) as Array<keyof ThemeColors>).forEach((key) => {
    vars[`${CSS_VAR_PREFIX}-color-${kebab(String(key))}`] = colors[key];
  });

  (Object.keys(theme.radii) as Array<keyof Theme['radii']>).forEach((key) => {
    vars[`${CSS_VAR_PREFIX}-radius-${kebab(String(key))}`] = theme.radii[key];
  });

  return vars;
}

/** Serialize a CSS-variable map into a `key:value;` declaration string. */
export function cssVarsToString(vars: Record<string, string>): string {
  return Object.entries(vars)
    .map(([key, value]) => `${key}: ${value};`)
    .join('\n');
}
